module.exports = __webpack_public_path__ + "static/media/step_img_04.91b8296a.png";